import { SUPPLIER_PAYMENTS_JOURNAL_CODE } from "~/hooks/purchasing/useSupplierPayments";

import type { AccountMovement } from "~/types/contabilidad";

/** What makes an asiento AP-owned is the `supplier_payments` row behind it — NOT its journal.
 *
 * `pay_supplier_invoices` books every pago in the PAGO_PROVEEDORES NACIONALES journal and links it
 * through `supplier_payments.account_movement_id`; its Proveedores (2103·) lines mirror
 * `supplier_invoices.saldo_clp`, so they are corrected via "Devolver a Pago Proveedores" instead of
 * being hand-edited or deleted (a DB trigger blocks that too).
 *
 * But Contabilidad also books comprobantes by hand in that same journal — honorarios, arriendos,
 * cruces — and those have no subledger behind them. Keying the lock on the journal alone trapped
 * them: no Editar, and Eliminar replaced by a "Devolver a Pago Proveedores" that doesn't apply.
 * So check the link, and fall back to locked only when the embed wasn't selected. */
const hasLiveSupplierPayment = (movement: AccountMovement) =>
  movement.supplier_payment === undefined ||
  movement.supplier_payment.some((payment) => !payment.is_reversed);

/** A draft asiento owned by Pagos a Proveedor: AP lines locked, corrected by returning the pago. */
export const isSupplierPaymentDraft = (movement: AccountMovement) =>
  !movement.is_published &&
  movement.journal?.code === SUPPLIER_PAYMENTS_JOURNAL_CODE &&
  hasLiveSupplierPayment(movement);
